import gql from "graphql-tag";

export const fragment_GetAmountResponse = gql`
  fragment GetAmountResponse on GetAmountResponse {
    value
  }
`;
